import type { ComponentType } from 'react'
import { AudioRecordingFlow } from './audio-recording/AudioRecordingFlow'
import { FreeSpeechFlow } from './free-speech/FreeSpeechFlow'
import { ProficiencyAssessmentFlow } from './proficiency-assessment/ProficiencyAssessmentFlow'
import { VoiceConversationFlow } from './voice-conversation/VoiceConversationFlow'

export type ProjectFlowProps = {
  projectId: string
  projectName: string
  language: string
  captchaEnabled: boolean
  taskReportingEnabled: boolean
  rewardConfig?: {
    type: string
    amount: number
  }
  typeConfig?: Record<string, unknown> | null
  progress: { completed: number; total: number }
  maxTasksPerUser: number
  onBack: () => void
  onCompleted: () => void
}

/**
 * Project types with custom multi-step flows register here.
 * Types NOT in this registry fall through to NectarTaskContent (standard task-by-task).
 */
export const PROJECT_FLOW_COMPONENTS = new Map<string, ComponentType<ProjectFlowProps>>([
  ['AUDIO_RECORDING', AudioRecordingFlow],
  ['FREE_SPEECH', FreeSpeechFlow],
  ['PROFICIENCY_ASSESSMENT', ProficiencyAssessmentFlow],
  ['VOICE_CONVERSATION', VoiceConversationFlow],
])
